// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar__toolbar___cS4u_","toolbar-button-color-change":"toolbar__toolbar-button-color-change___ew-dI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/Toolbar/toolbar.scss
// module id = 946
// module chunks = 0